import {Component} from '@angular/core';
import {CrudUploadsService} from '@shared/services/crud-uploads.service';
import {ShareddataService} from '@shared/services/shareddata.service';
import {ApiFactoryService} from '@shared/services/api-factory.service';
import {AbstractBffApi} from '@models/sharedinterface';
import {AbstractCrudListComponent} from '@shared/library/crud-library/abstract-crud-list.component';
import {Router} from '@angular/router';
import {IDisplayColumn} from '@shared/library/crud-library/crud-list/crud-list.component';
import {CrudAttributeService} from '@shared/services/crud-attribute.service';
import {AlertService} from '@shared/services/alert.service';

@Component({
  selector: 'app-uploads-list',
  templateUrl: './uploads-list.component.html',
  styleUrls: ['./uploads-list.component.scss']
})
export class UploadsListComponent extends AbstractCrudListComponent {

  private bffapi: AbstractBffApi;

  createButtonLabel: string;

  constructor(router: Router, httpCrud: CrudUploadsService,
              protected sharedData: ShareddataService,
              private apifactory: ApiFactoryService,
              protected alertService: AlertService) {
    super(router, httpCrud, alertService);

    this.bffapi = this.apifactory.createBffApi();

    this.createButtonLabel = 'Upload new file';

    this.entityroot = '/admin/uploads';

    this.editpathprefix = this.entityroot + '/';

    this.createlink = this.entityroot + '/create';

    // Set here the list of columns to display
    this.displayedcolumns = [
      {columnName: 'id', label: 'ID'},
      {columnName: 'appclientid', label: 'Client'},
      {columnName: 'uri', label: 'URI'}
    ] as IDisplayColumn[];
  }

  getPostTreatmentCallback(): any {
    return (data: any): any => {

      // Gets app clients if not already fetched
      if (this.sharedData.getAppClients().length === 0) {
        this.bffapi.getClients().subscribe(({results}) => {
          this.sharedData.setAppClients(results);
        });
      }

      return data.results;
    };
  }

  getAppClientLabel(id: number) {
    return this.sharedData.getAppClients().find(ac => ac.id === id).label;
  }

  copyLink(uri) {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = uri;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
  }

}
